<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">

      <v-data-table
        :headers="headers"
        :items="filteredVideos"
        item-key="id"
        class="elevation-1 mytable"
        :search="search"
        v-if="subject_videos_list.length>0"
      >

        <template v-slot:top>
          <v-toolbar flat color="white" class="toolbar">
            <v-toolbar-title>Digital Content</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-row class="mt-4 px-4" align="center" justify="center" style="gap: 16px;">
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="language"
                :items="language_list"
                item-text="name"
                item-value="id"
                label="Content Language"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.srno="{ item }">
          {{ filteredVideos.indexOf(item) + 1 }}
        </template>

        <template v-slot:item.filepath="{ item }">
          <v-icon
            :color="item.filepath ? 'blue' : 'grey'"
            :style="{ cursor: item.filepath ? 'pointer' : 'not-allowed' }"
            @click="item.filepath ? openVideoPage(item) : null"
          >
            mdi-video
          </v-icon>
        </template>
      </v-data-table>

       <div class="empty-state" v-else>
           <v-icon size="64" color="#b0bec5">mdi-book-open-outline</v-icon>
            <p class="empty-text">Videos Not Present For This Subject</p>
       </div>

    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
import axios from "axios";
const BASE_URL = process.env.VUE_APP_CONTENT_URL;

export default {
  data: () => ({
    overlay: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    loader: false,

    headers: [
      { text: "Sr. No", value: "srno", sortable: false },
      { text: "Chapter Name", value: "chapter" },
      { text: "Topic", value: "topic_name" },
      { text: "Content", value: "filepath" },
    ],
    subject_videos_list: [],
    language_list: [],
    language: null,
  }),

  computed: {
    filteredVideos() {
    let data = this.subject_videos_list;

    if (this.language) {
      data = data.filter(item => item.language_id == this.language);
    }

    if (this.search) {
      const txt = this.search.toLowerCase();
      data = data.filter(item =>
        (item.topic_name || "").toLowerCase().includes(txt) ||
        (item.chapter || "").toLowerCase().includes(txt)
      );
    }

    return data;
  }
  },

  mounted() {
    this.subject_name = sessionStorage.getItem("subject_name") || "";
    this.subject_code = sessionStorage.getItem("subject_code") || "";
    this.onLoad();
  },

  methods: {

    onLoad() {
      this.overlay = true;
      const data = {
        subject_name: this.subject_name,
        subject_code: this.subject_code,
      };
      axios.post(BASE_URL + "/subjectCatalogue/getSubjectsVideoList", data)
        .then((res) => {
          if (res.data.flag === "true") {
            this.subject_videos_list = res.data.subject_videos_list || [];
            this.language_list = res.data.language_list || [];

            if(this.subject_videos_list.length > 0){
              this.language = this.subject_videos_list[0].language_id;
            }
          } else {
            this.showSnackbar("red", res.data.msg);
          }
        })
        .catch(() => {
          this.showSnackbar("red", "Failed to load videos");
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    openVideoPage(item) {
            const list  = this.filteredVideos
            const index = list.indexOf(item)

            localStorage.setItem('videoUrl',      item.filepath)
            localStorage.setItem('chapter_name',  item.chapter)
            localStorage.setItem('topic',         item.topic_name)
            localStorage.setItem('video_index',   index)
            localStorage.setItem('video_list', JSON.stringify(
                list.map(v => ({
                video_url:    v.filepath,      
                chapter_name: v.chapter,       
                topic_name:   v.topic_name   
                })) 
            ))

            this.$router.push({ name: 'videos' })
        },

    showSnackbar(color, msg) {
      this.snackbar = true;
      this.color = color;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      console.log("Edit", item);
    },

    deleteItem(item) {
      console.log("Delete", item);
    },

    toggle(item) {
      console.log("Toggle", item);
    }
  }
};
</script>

<style scoped>
.mytable thead th {
  background: #0f2027;
  background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
  background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
  color: white !important;
  font-weight: bold;
  text-align: center;
}

.edit-avatar {
  border: 1px solid #b0bec5;
  cursor: pointer;
}

.delete-avatar {
  border: 1px solid #b0bec5;
  cursor: pointer;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
}

.empty-text {
  font-size: 16px;
  font-weight: 600;
  color: #90a4ae;
  margin: 0;
}
</style>